import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enElement from 'element-ui/lib/locale/lang/en';
import zhElement from 'element-ui/lib/locale/lang/zh-CN';
import trElement from 'element-ui/lib/locale/lang/tr-TR';
import viElement from 'element-ui/lib/locale/lang/vi';
import localZh from './zh';
import localEn from './en';
import localTr from './tr';
import localVi from './vi';
import config from '../config';

Vue.use(VueI18n);
// 现在包含中英两种语言 如若需要其他语言请在 http://element-cn.eleme.io/#/zh-CN/component/i18n 中寻找
const localeMessages = {
  en: {
    ...localEn,
    ...enElement
  },
  zh: {
    ...localZh,
    ...zhElement
  },
  tr: {
    ...localTr,
    ...trElement
  },
  vi: {
    ...localVi,
    ...viElement
  }
};
export default new VueI18n({
  locale: localStorage.lang || config.LANG, // 语言存储在 localStorage 中，切换语言时 记得更新这个值，否则下次进入应用 依然是默认语言
  messages: localeMessages // set locale messages
});
